import { useLocation, Navigate, Outlet } from 'react-router-dom';
import { useAppSelector } from '../app/store';

const RequireAuth = () => {
  const access = useAppSelector((state) => state.auth.user);
  const location = useLocation();
  return access ? <Outlet /> : <Navigate to="/login" state={{ from: location }} replace />;
};
export default RequireAuth;
